import { useDispatch, useSelector } from "react-redux";
import { RootState } from "reducers";
import { Navigate, Outlet } from "react-router-dom";
import { useGetStaffInfoQuery } from "apis/services/auth";
import { useEffect } from "react";
import { setUserInfo } from "reducers/authReducer";
import usePermissions from "hooks/usePermission";
import { PermissionCodename } from "constants/permission";
import filterByPermissions from "utils/filterByPermissions";
interface ProtectedOutletProps {
  requiredPermission?: PermissionCodename;
  children?: React.ReactNode;
}

export const fallbackRoutes = [
  {
    path: "/",
    permission: "view_dashboard" as PermissionCodename,
  },
  {
    path: "/calendar",
    permission: "view_calendar" as PermissionCodename,
  },
  {
    path: "/requests",
    permission: "view_requests" as PermissionCodename,
  },
  {
    path: "/reports",
    permission: "view_reports" as PermissionCodename,
  },
  {
    path: "/integration",
    permission: "view_integrations" as PermissionCodename,
  },
];
export default function ProtectedOutlet({
  requiredPermission,
  children,
}: ProtectedOutletProps) {
  const dispatch = useDispatch();
  const token = useSelector((state: RootState) => state.auth.token);

  const { data } = useGetStaffInfoQuery(undefined, {
    skip: !token,
  });

  const { hasPermissionTo } = usePermissions();

  useEffect(() => {
    if (data) dispatch(setUserInfo(data));
  }, [data]);

  const allowedRoutes = filterByPermissions(fallbackRoutes, hasPermissionTo);

  const firstAllowedRoute = allowedRoutes[0]?.path || "/";

  if (!token) return <Navigate to="/auth" replace />;

  if (requiredPermission && !hasPermissionTo(requiredPermission)) {
    return <Navigate to={firstAllowedRoute} replace />;
  }

  return <>{children ?? <Outlet />}</>;
}
